export default "__VITE_ASSET__7d5b7094__"